// Brand tokens, the same values as admin-frontend/src/theme/brands.js (see
// DESIGN.md). Both brands share the survey-sheet world (ground, rules, state
// inks); each owns its rail ground and its action ink.

export const SHARED = {
  ground: '#F4F6F2',
  surface: '#FFFFFF',
  head: '#EEF2EC',
  hover: '#F0F4EE',
  rule: '#D9E0D8',
  ruleStrong: '#C4CEC3',
  ink: '#1D2A22',
  inkMuted: '#56655B',
  // Map-legend state inks, the same in every brand and on the live map
  state: {
    good: '#3F7D3A',
    warning: '#9A6212',
    critical: '#B3362B',
    neutral: '#5F6B64'
  }
}

// The same inks, lifted for the dark theme's grounds
export const SHARED_DARK = {
  ground: '#121814',
  surface: '#1A231D',
  rule: '#2E3A32',
  ink: '#E6ECE6',
  inkMuted: '#A3B0A6',
  state: {
    good: '#79B868',
    warning: '#D49A45',
    critical: '#E06A5D',
    neutral: '#9AA59E'
  }
}

export const BRANDS = {
  lewoo: {
    id: 'lewoo',
    name: 'LewooTrack',
    rail: '#24372B',
    railActive: '#33503F',
    railText: '#E4EBE4',
    railMuted: '#9FB7A5',
    railMark: '#8DBA74',
    action: '#2D6A9F',
    actionDark: '#245683',
    actionTint: '#E3EDF6',
    actionOnDark: '#7FB0DC'
  },
  eneo: {
    id: 'eneo',
    name: 'EneoTransportation',
    rail: '#14324F',
    railActive: '#22476B',
    railText: '#E2EAF2',
    railMuted: '#9DB3C9',
    railMark: '#E8A365',
    action: '#B5520F',
    actionDark: '#94430C',
    actionTint: '#F8EADF',
    actionOnDark: '#E8945A'
  }
}

// An Eneo host gets the Eneo brand. REACT_APP_BRAND overrides it, and in
// development so does `?brand=eneo` in the URL.
function devOverride() {
  if (process.env.NODE_ENV !== 'development') return null
  return new URLSearchParams(window.location.search).get('brand')
}

export function resolveBrand(
  host = window.location.host,
  override = devOverride() || process.env.REACT_APP_BRAND
) {
  if (override && BRANDS[override]) return BRANDS[override]
  return /eneo/i.test(host) ? BRANDS.eneo : BRANDS.lewoo
}
